"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivationCodeChannelType = void 0;
/**
 * 激活码获取渠道 - space|空间福利 system|系统奖励
 */
var ActivationCodeChannelType;
(function (ActivationCodeChannelType) {
    ActivationCodeChannelType["SPACE"] = "space";
    ActivationCodeChannelType["SYSTEM"] = "system";
})(ActivationCodeChannelType = exports.ActivationCodeChannelType || (exports.ActivationCodeChannelType = {}));
